import { BuilderElement } from '@builder.io/sdk';
import { Builder } from '@builder.io/react';
import useSWR from 'swr';
import { fetchGuidedRecipe } from '../../../rest/zapier';
import { Item, Props } from './ZapCardSection';

export const fetchZapTemplates = async (items: Item[]) =>
  Promise.all(
    (items || []).map(async (item: Item) => {
      if (!item.zapTemplateID) return item;
      const zapTemplate = await fetchGuidedRecipe(item.zapTemplateID);
      return {
        ...item,
        ...zapTemplate,
        // Use the title/href from API if none was input by the Builder user.
        title: item.title || zapTemplate.title,
        href: item.href || zapTemplate.href,
        color: item.color || zapTemplate.color,
      };
    }),
  );

export const useUnregisteredProps = (props: Props) => {
  const { data } = useSWR(
    `zap-templates/${JSON.stringify(props.items || [])}`,
    async () => {
      if (Builder.isEditing || Builder.isPreviewing) {
        try {
          return (await fetchZapTemplates(props.items)) as Item[];
        } catch (e) {
          return props.items;
        }
      }
      return props.items;
    },
  );

  return { ...props, items: data };
};

export const transformZapCardSection = async (block: BuilderElement) => {
  const zapTemplates = await fetchZapTemplates(
    block?.component?.options?.items || [],
  );
  return {
    ...block,
    component: {
      ...block?.component,
      options: { ...block?.component?.options, items: zapTemplates },
    },
  };
};
